export enum UploadStatus {
    Open = 'Open',
    Validation = 'Validation',
    InProgress = 'InProgress'
}
